// B1 - Ünite 2: Future - Going to
// Hedef: Be going to + fiil, planlar vs tahminler

export const B1_UNIT_2 = {
  'B1-U2-L1': {
    id: 'B1-U2-L1',
    title: 'Am/Is/Are going to + fiil',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Going to - Yapı',
          explanation: 'Be going to + fiil: Önceden planlanmış gelecek eylemler veya kanıta dayalı tahminler için kullanılır.',
          table: {
            headers: ['Şahıs', 'Be', 'Going to + Fiil'],
            rows: [
              ['I', 'am', 'going to apply'],
              ['You/We/They', 'are', 'going to travel'],
              ['He/She/It', 'is', 'going to rain']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Havacılık Örnekleri',
          table: {
            headers: ['Cümle', 'Türkçesi', 'Kullanım'],
            rows: [
              ['I am going to apply for the cabin crew position.', 'Kabin memurluğu pozisyonuna başvuracağım.', 'Plan'],
              ['We are going to serve lunch soon.', 'Yakında öğle yemeği servis edeceğiz.', 'Plan'],
              ['Look at those clouds! It is going to be turbulent.', 'Şu bulutlara bak! Türbülans olacak.', 'Kanıta dayalı tahmin'],
              ['The passenger is going to faint! (Yüzü beyaz)', 'Yolcu bayılacak!', 'Kanıta dayalı tahmin']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Going to = Plan veya kanıta dayalı tahmin | Will = Anlık karar veya genel tahmin'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'I _____ apply for the job next week. (plan)',
          options: ['am going to', 'will', 'going to', 'am go to'],
          correct: 'am going to',
          explanation: 'Plan: am/is/are going to'
        },
        {
          type: 'multipleChoice',
          question: 'She _____ start her training tomorrow. (plan)',
          options: ['is going to', 'are going to', 'am going to', 'going to'],
          correct: 'is going to',
          explanation: 'She = is going to'
        },
        {
          type: 'fillInBlank',
          sentence: 'We _____ (going to / serve) dinner in 30 minutes.',
          answer: 'are going to serve',
          hint: 'We = are going to'
        },
        {
          type: 'fillInBlank',
          sentence: 'Look! The plane _____ (going to / land).',
          answer: 'is going to land',
          hint: 'The plane = is going to'
        },
        {
          type: 'dragDrop',
          instruction: '🔀 Cümleyi doğru sıraya dizin',
          words: ['going', 'am', 'I', 'to', 'apply'],
          correctOrder: [2, 1, 0, 3, 4],
          translation: 'Başvuracağım.'
        },
        {
          type: 'flashcard',
          title: '🎴 Going to Kalıpları',
          cards: [
            { front: 'I am going to', back: '...acağım/eceğim' },
            { front: 'You are going to', back: '...acaksın/eceksin' },
            { front: 'He/She is going to', back: '...acak/ecek' },
            { front: 'We are going to', back: '...acağız/eceğiz' },
            { front: 'They are going to', back: '...acaklar/ecekler' }
          ]
        },
        {
          type: 'timeRace',
          title: '⏱️ Will mi Going to mu?',
          cards: [
            { front: 'Plan: I ___ study tonight', back: 'am going to' },
            { front: 'Teklif: I ___ help you!', back: 'will' },
            { front: 'Bulutlar var: It ___ rain', back: 'is going to' },
            { front: 'Söz: I ___ call you', back: 'will' },
            { front: 'Bilet aldım: I ___ fly', back: 'am going to' },
            { front: 'Tahmin: It ___ be nice', back: 'will' }
          ]
        }
      ]
    }
  },
  'B1-U2-L2': {
    id: 'B1-U2-L2',
    title: 'Will vs Going to',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Will vs Going to Karşılaştırma',
          table: {
            headers: ['Will', 'Going to'],
            rows: [
              ['Anlık karar', 'Önceden planlanmış'],
              ['Genel tahmin', 'Kanıta dayalı tahmin'],
              ['Söz, teklif', '-'],
              ['I\'ll help you!', 'I\'m going to study tonight.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Karşılaştırma Örnekleri',
          table: {
            headers: ['Durum', 'Will', 'Going to'],
            rows: [
              ['Teklif', 'I\'ll get you some water.', '-'],
              ['Plan', '-', 'I\'m going to visit Paris next month.'],
              ['Genel tahmin', 'It will be a nice day.', '-'],
              ['Kanıta dayalı', '-', 'Look at those clouds! It\'s going to rain.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Telefon çalıyor: I\'ll answer it! (anlık) | Yarın saat 10\'da toplantım var: I\'m going to attend a meeting. (plan)'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'The phone is ringing. I _____ answer it.',
          options: ['will', 'am going to', 'going to', 'would'],
          correct: 'will',
          explanation: 'Anlık karar = will'
        },
        {
          type: 'multipleChoice',
          question: 'I have a ticket. I _____ fly to London tomorrow.',
          options: ['am going to', 'will', 'would', 'going to'],
          correct: 'am going to',
          explanation: 'Plan (bilet var) = going to'
        },
        {
          type: 'multipleChoice',
          question: 'Look at the sky! It _____ rain.',
          options: ['is going to', 'will', 'would', 'going to'],
          correct: 'is going to',
          explanation: 'Kanıta dayalı tahmin (bulutlar var) = going to'
        },
        {
          type: 'matching',
          instruction: 'Will vs Going to',
          pairs: [
            { left: 'Anlık karar', right: 'will' },
            { left: 'Önceden plan', right: 'going to' },
            { left: 'Kanıta dayalı tahmin', right: 'going to' },
            { left: 'Genel tahmin', right: 'will' }
          ]
        }
      ]
    }
  },
  'B1-U2-L3': {
    id: 'B1-U2-L3',
    title: 'Olumsuz ve Soru',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Going to - Olumsuz',
          explanation: 'Olumsuz: am/is/are + not + going to + fiil',
          table: {
            headers: ['Olumlu', 'Olumsuz', 'Kısa Form'],
            rows: [
              ['I am going to fly.', 'I am not going to fly.', 'I\'m not going to fly.'],
              ['She is going to apply.', 'She is not going to apply.', 'She isn\'t going to apply.'],
              ['We are going to wait.', 'We are not going to wait.', 'We aren\'t going to wait.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '📚 Going to - Soru',
          table: {
            headers: ['Soru', 'Kısa Cevap (+)', 'Kısa Cevap (-)'],
            rows: [
              ['Are you going to apply?', 'Yes, I am.', 'No, I\'m not.'],
              ['Is she going to fly?', 'Yes, she is.', 'No, she isn\'t.'],
              ['What are you going to do?', '-', '-']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Mülakatta: "What are you going to do if you get this job?" sorusuna hazırlıklı olun!'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'She _____ apply for that position.',
          options: ['isn\'t going to', 'aren\'t going to', 'not going to', 'don\'t going to'],
          correct: 'isn\'t going to',
          explanation: 'She = is not / isn\'t going to'
        },
        {
          type: 'multipleChoice',
          question: '_____ you going to attend the interview?',
          options: ['Are', 'Is', 'Do', 'Will'],
          correct: 'Are',
          explanation: 'You = Are you going to...?'
        },
        {
          type: 'fillInBlank',
          sentence: 'What _____ you going to do after the flight?',
          answer: 'are',
          hint: 'Soru: What are you going to...?'
        }
      ]
    }
  },
  'B1-U2-L4': {
    id: 'B1-U2-L4',
    title: 'Evidence-based Predictions',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Kanıta Dayalı Tahmin',
          explanation: 'Gördüğümüz veya bildiğimiz bir kanıta dayalı tahminlerde "going to" kullanırız.',
          table: {
            headers: ['Kanıt', 'Tahmin'],
            rows: [
              ['The sky is very dark.', 'It\'s going to rain.'],
              ['The passenger looks pale.', 'He\'s going to faint.'],
              ['The plane is shaking.', 'There\'s going to be turbulence.'],
              ['She studied hard.', 'She\'s going to pass.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Havacılık Tahminleri',
          table: {
            headers: ['Kanıt', 'Tahmin'],
            rows: [
              ['Look at the weather report!', 'We\'re going to have delays.'],
              ['The fuel is low.', 'We\'re going to need to refuel.'],
              ['All seats are taken.', 'It\'s going to be a full flight.'],
              ['The passenger is sweating.', 'He\'s going to be sick.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Kanıt varsa = GOING TO | Genel fikir/tahminse = WILL'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Look at those dark clouds! It _____ rain.',
          options: ['is going to', 'will', 'would', 'is'],
          correct: 'is going to',
          explanation: 'Kanıt (dark clouds) var = going to'
        },
        {
          type: 'multipleChoice',
          question: 'The passenger looks very pale. I think he _____ faint.',
          options: ['is going to', 'will', 'would', 'is'],
          correct: 'is going to',
          explanation: 'Kanıt (pale) var = going to'
        },
        {
          type: 'fillInBlank',
          sentence: 'The plane is shaking. There _____ (going to / be) turbulence.',
          answer: 'is going to be',
          hint: 'Kanıt var = going to'
        }
      ]
    }
  },
  'B1-U2-L5': {
    id: 'B1-U2-L5',
    title: 'Uygulama: Uçuş Planı',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '✈️ Uçuş Planı - Going to',
          table: {
            headers: ['Plan', 'Cümle'],
            rows: [
              ['Kalkış', 'We\'re going to take off at 14:00.'],
              ['Servis', 'We\'re going to serve lunch after takeoff.'],
              ['Varış', 'We\'re going to arrive at 18:30.'],
              ['Transfer', 'A bus is going to take you to the terminal.']
            ]
          }
        },
        {
          type: 'vocabulary',
          title: '🎤 Mülakat: Gelecek Planları',
          words: [
            { en: 'I\'m going to improve my English.', tr: 'İngilizcemi geliştireceğim.', pronunciation: '' },
            { en: 'I\'m going to get more experience.', tr: 'Daha fazla deneyim kazanacağım.', pronunciation: '' },
            { en: 'I\'m going to work in this industry.', tr: 'Bu sektörde çalışacağım.', pronunciation: '' },
            { en: 'I\'m going to give my best.', tr: 'Elimden gelenin en iyisini yapacağım.', pronunciation: '' }
          ]
        },
        {
          type: 'tip',
          content: '💡 Mülakatta plan soruları için GOING TO kullanın!'
        }
      ],
      exercises: [
        {
          type: 'speaking',
          instruction: 'Bu planları söyleyin:',
          phrases: [
            'I\'m going to apply for this position.',
            'I\'m going to work hard every day.',
            'I\'m going to learn from experienced colleagues.',
            'I\'m going to provide excellent service.'
          ]
        },
        {
          type: 'fillInBlank',
          sentence: 'After the interview, I _____ (going to / wait) for the results.',
          answer: 'am going to wait',
          hint: 'I = am going to'
        },
        {
          type: 'multipleChoice',
          question: 'What _____ you going to do if you get this job?',
          options: ['are', 'is', 'will', 'do'],
          correct: 'are',
          explanation: 'What are you going to...?'
        }
      ]
    }
  },
  'B1-U2-EXAM': {
    id: 'B1-U2-EXAM',
    title: 'Ünite 2 Sınavı',
    type: 'exam',
    exercises: [
      {
        type: 'multipleChoice',
        question: 'I have a plan. I _____ apply for the job tomorrow.',
        options: ['am going to', 'will', 'going to', 'would'],
        correct: 'am going to',
        explanation: 'Plan = going to'
      },
      {
        type: 'multipleChoice',
        question: 'Look at those clouds! It _____ rain.',
        options: ['is going to', 'will', 'would', 'is'],
        correct: 'is going to',
        explanation: 'Kanıta dayalı tahmin = going to'
      },
      {
        type: 'multipleChoice',
        question: 'The phone is ringing. I _____ answer it.',
        options: ['will', 'am going to', 'going to', 'would'],
        correct: 'will',
        explanation: 'Anlık karar = will'
      },
      {
        type: 'multipleChoice',
        question: '_____ she going to attend the interview?',
        options: ['Is', 'Are', 'Does', 'Will'],
        correct: 'Is',
        explanation: 'She = Is she going to...?'
      },
      {
        type: 'fillInBlank',
        sentence: 'We _____ (not / going to) delay the flight.',
        answer: 'are not going to',
        hint: 'We = are not going to / aren\'t going to'
      },
      {
        type: 'matchPairs',
        instruction: 'Will vs Going to',
        pairs: [
          { left: 'Anlık karar', right: 'will' },
          { left: 'Önceden plan', right: 'going to' },
          { left: 'Kanıta dayalı', right: 'going to' },
          { left: 'Söz/Teklif', right: 'will' }
        ]
      }
    ]
  }
};

export default B1_UNIT_2;
